<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold py-3">گزارش فروش</h5>
        <div style="flex: 1"></div>
        <ExcelDownload
          :extraQuery="extraQuery"
          :url="
            `/admin/reports/sell?start_date=${filter.date.startDate}&end_date=${filter.date.endDate}`
          "
        />
      </div>
      <div class="row px-4 not-in-print">
        <form
          autocomplete="new-password"
          @submit.prevent="doFilter"
          class="col-12 row"
        >
          <div class="col-6">
            <DatePickerRange v-model="filter.date" />
          </div>
          <div class="col-6 d-flex align-items-center">
            <b-form-checkbox v-model="filter.subtractShipping">
              <span class="pr-5">
                کم کردن وزن حمل و نقل
              </span>
            </b-form-checkbox>
          </div>
          <div class="col-12 d-flex justify-content-end">
            <button :disabled="disabled" type="submit" class="btn btn-primary">
              فیلتر
            </button>
          </div>
        </form>
      </div>
      <b-list-group class="totals-row px-4" v-if="totals">
        <b-list-group-item class="totals-item">
          <span>
            تعداد اقلام فروش رفته :
          </span>
          <span>{{ totals.items_count | price }} </span>
        </b-list-group-item>

        <b-list-group-item class="totals-item">
          <span>
            جمع اقلام فروش رفته :
          </span>
          <span>{{ totals.amount | price }} </span>
        </b-list-group-item>
        <b-list-group-item class="totals-item">
          <span>
            جمع تخفیفات:
          </span>
          <span>{{ totals.discount_amount | price }} </span>
        </b-list-group-item>
        <b-list-group-item class="totals-item" v-if="!filter.subtractShipping">
          <span>جمع حمل و نقل:</span>
          <span>{{ totals.shipping | price }} </span>
        </b-list-group-item>
        <b-list-group-item class="totals-item">
          <span>جمع پرداختی درگاه:</span>
          <span>
            {{ totals.gateway_paid_total | price }}
          </span>
        </b-list-group-item>
        <b-list-group-item class="totals-item">
          <span>جمع بن:</span>
          <span>
            {{ totals.bon_value | price }}
          </span>
        </b-list-group-item>
      </b-list-group>
      <div id="print" class="p-4">
        <b-table
          id="main-table"
          v-if="reports"
          bordered
          striped
          :fields="fields"
          :items="reports.data"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          responsive="sm"
        >
          <template v-slot:cell(row)="data">
            {{ (reports.from || 1) + data.index }}
          </template>
          <template v-slot:cell(id)="data">
            {{ data.item.id }}
          </template>
          <template v-slot:cell(total_amount_without_discount)="data">
            {{ data.item.total_amount_without_discount | price }}
          </template>
          <template v-slot:cell(total_discount_amount)="data">
            {{ data.item.total_discount_amount | price }}
          </template>
          <template v-slot:cell(total_club_discount_amount)="data">
            {{ data.item.total_club_discount_amount | price }}
          </template>
          <template v-slot:cell(bon_value)="data">
            {{ data.item.bon_value | price }}
          </template>
          <template v-slot:cell(shipping_amount)="data">
            {{ data.item.shipping_amount | price }}
          </template>
          <!-- <template v-slot:cell(gateway_payments)="data">
            {{ data.item.gateway_payments[0].amount | price }}
            {{ data.item.gateway_payments[0].name }}
          </template> -->
          <template v-slot:cell(gateway_payments)="data">
            <span
              v-if="data.item.gateway_payments && data.item.gateway_payments[0]"
            >
              {{ data.item.gateway_payments[0].amount | price }}
              {{ data.item.gateway_payments[0].name }}
            </span>
            <span v-else>-</span>
          </template>
          <template v-slot:cell(created_at)="data">
            {{ data.item.created_at | persianDate }}
          </template>
          <template v-slot:cell(wallet_paid)="data">
            {{ data.item.wallet_paid | price }}
          </template>
        </b-table>
        <div v-else-if="reports == ''" class="alert alert-danger">
          موردی یافت تشد
        </div>
        <div v-else class="alert alert-primary">در حال بارگزاری</div>
      </div>
      <pagination
        :router="true"
        v-if="reports && reports.data != ''"
        :disabled="disabled"
        :limit="2"
        :data="reports"
        @pagination-change-page="changePage"
      />
    </div>
  </main>
</template>

<script>
import {
  BTable,
  BFormGroup,
  BFormInput,
  BListGroup,
  BListGroupItem,
  BFormCheckbox,
} from "bootstrap-vue";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import configProvider from "@@/core/configProvider";
import reportMixin from "@@/core/mixins/reportMixin";
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload.vue";
import digipayTransactionsImpl from "../../digipayTransactions/digipayTransactionsImpl";

function Filter() {
  this.subtractShipping = false;
  this.date = {
    startDate: "",
    endDate: "",
  };
}

Filter.prototype.set = function(filters) {
  Object.entries(filters).forEach(([index, value]) => {
    this[index] = value;
  });
};

export default {
  name: "shopinoReport",
  components: {
    DatePickerRange,
    BTable,
    BFormGroup,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BFormCheckbox,
    ExcelDownload,
    digipayTransactionsImpl,
  },
  configProvider,
  data() {
    return {
      disabled: false,
      search: "",
      totals: {
        amount: null,
        items_count: null,
      },
      // fields: [
      //   {
      //     key: "row",
      //     label: "ردیف",
      //   },
      //   {
      //     key: "id",
      //     label: "شناسه فاکتور",
      //   },
      //   {
      //     key: "total_amount_without_discount",
      //     label: "مبلغ فاکتور",
      //   },
      //   {
      //     key: "total_discount_amount",
      //     label: "تخفیف",
      //   },
      //   {
      //     key: "shipping_amount",
      //     label: "حمل و نقل",
      //   },
      //   {
      //     key: "created_at",
      //     label: "تاریخ",
      //   },
      //   {
      //     key: "created_at",
      //     label: "درگاه",
      //   },
      //   {
      //     key: "created_at",
      //     label: "کیف",
      //   },

      // ],
      page: 1,
      reports: null,
      list: [],
      sortBy: null,
      sortDesc: null,
      filter: new Filter(),
      appliedFilter: new Filter(),
      showVarietiesProductId: null,
      sumTotalSale: null,
      sumSellQuantity: null,
      widgetData: {},
    };
  },
  mixins: [reportMixin],
  watch: {
    "$route.query": {
      handler(nV) {
        if (nV.page) {
          this.changePage(nV.page);
        }
      },
    },
  },
  computed: {
    fields() {
      const fields = [
        { key: "row", label: "ردیف" },
        { key: "id", label: "شناسه فاکتور" },
        { key: "total_amount_without_discount", label: "مبلغ فاکتور" },
        { key: "total_discount_amount", label: "تخفیف" },
        { key: "total_club_discount_amount", label: "تخفیف کلاب" },
        { key: "bon_value", label: "بن" },
        { key: "shipping_amount", label: "حمل و نقل" },
        { key: "created_at", label: "تاریخ" },
        { key: "gateway_payments", label: "درگاه" },
        { key: "wallet_paid", label: "کیف" },
      ];

      // اگه تیک خورده بود، ستون حمل و نقل رو حذف کن

      return this.filter.subtractShipping
        ? fields.filter((f) => f.key !== "shipping_amount")
        : fields;
    },
    extraQuery() {
      return {
        from_date: this.filter.date.startDate,
        to_date: this.filter.date.endDate,
      };
    },
  },
  methods: {
    removeFilter() {
      this.filter = new Filter();
      this.loadData();
    },

    doFilter() {
      this.showVarietiesProductId = null;
      this.loadData();
    },
    changePage(page = 1) {
      this.previousPage = this.page;
      this.page = page;
      this.loadData();
    },

    async loadData() {
      try {
        this.appliedFilter.set(this.filter);
        this.disabled = true;
        const response = await this.$axios.get("admin/reports/sell", {
          params: {
            start_date: this.appliedFilter.date.startDate,
            end_date: this.appliedFilter.date.endDate,
            page: this.page,
          },
        });
        this.reports = response.data.data.orders;
        this.totals = response.data.data.totals;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>
<style scoped>
.totals-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  margin: 15px 0;
}

.totals-item {
  flex: 1 1 200px;
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  border: 1px solid #e3e3e3;
  border-radius: 6px;
  background: #fff;
}

.totals-item span:first-child {
  font-weight: bold;
  margin-bottom: 5px;
}
</style>
<style>
.print-only {
  display: none;
}

@media print {
  .not-in-print {
    display: none !important;
  }

  .app-content .side-app {
    padding: 0 !important;
  }

  .print-only {
    display: block !important;
  }

  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
    font-size: 1.25rem;
  }
  #print {
    padding: 0 !important;
  }
  #print {
    width: 80%;
  }

  #main-table th:last-child,
  #main-table td:last-child {
    display: none;
  }

  #print .not-in-print {
    display: none;
  }

  .mr-2-print {
    margin-right: 20px;
  }
}
</style>
